import BottomLine from 'assets/Affiliate/BottomLine';
import React from 'react';

interface HeroSectionProps {
  title?: React.ReactNode;
  subtitle?: string;
  showLearnerCommitment?: boolean;
}

const HeroSection: React.FC<HeroSectionProps> = ({
  title = 'Become a ZebraLearn Member for the Best Learning Experience',
  subtitle = 'Get unlimited access to any title you like',
  showLearnerCommitment = false,
}) => {
  return (
    <div className='px-4 relative md:min-h-[380px] min-h-[320px] md:py-16 py-12 flex flex-col items-center justify-center bg-subscription-bg md:bg-cover bg-inherit bg-center'>
      <div
        style={{
          background: `linear-gradient(270deg, rgba(0,0,0,0) 0%, rgba(0,0,0,0.7) 100%), linear-gradient(180deg, rgba(18,18,18,0.5) 0%, var(--black-shades-100, #000) 100%)`,
        }}
        className='absolute top-0 left-0 w-full h-full z-10'
      ></div>
      <h1 className='md:text-[32px] text-xl md:leading-[44px] leading-7 text-white font-semibold text-center max-w-2xl md:mb-3 mb-2 z-20'>
        {title}
      </h1>
      <p className='md:text-base text-sm font-normal text-grayZl-400 z-20 text-center'>
        {subtitle}
      </p>
      {showLearnerCommitment && (
        <div className='z-20 text-center md:mt-10 mt-6 md:flex hidden flex-wrap items-center justify-center gap-x-1.5 md:text-xl text-sm font-normal text-grayZl-400'>
          <span>Zebralearn Prime</span>
          <span className='relative inline-flex flex-col items-center text-white font-semibold pb-0.5 md:pb-0.5'>
            <span>Learners Learn 2.2x</span>
            <BottomLine className='absolute -bottom-3 md:-bottom-4 left-0 w-full h-auto pointer-events-none' />
          </span>
          <span>More Because Of Their Commitment</span>
        </div>
      )}
    </div>
  );
};

export default HeroSection;

